import { createEntityAdapter } from "@reduxjs/toolkit";

import type { Profile } from "Types/Profile";

export const contactsAdapter = createEntityAdapter<Profile>();
